import { Component, Input, NgZone, OnDestroy } from "@angular/core";
import moment from 'moment';
import { Subscription } from "rxjs";
import { LoggerService } from "../../../../common/logging/logger.service";
import { ModalDialogComponent } from "../../../../common/modal/modalDialog.component";
import { OfficeSelectorService } from "../../../../common/officeSelector/officeSelector.service";
import { FitActiveWorkersWoMedicalExaminationDirectService, FitActiveWorkersWoMedicalExaminationDirectServiceData } from "../../services/occupationalRiskPreventionKpi/fitActiveWorkersWoMedicalExaminationDirect.service";
import { FitActiveWorkersWoMedicalExaminationDirectDetailService, FitActiveWorkersWoMedicalExaminationDirectDetailServiceData, FitWorkerDetail } from "../../services/occupationalRiskPreventionKpi/fitActiveWorkersWoMedicalExaminationDirectDetail.service";
import { ColumnDefinition, DateColumnDefinition, EmailColumnDefinition, PhoneNumberColumnDefinition, TextColumnDefinition } from "../../../../dashboardCommon/components/cardDetails/datatable.component";
import { DualSummaryDetailKpiServiceHost } from "../../../../dashboardCommon/components/kpiServiceHostComponent";
import { ImpersonationService } from "src/app/auth/apigee/impersonation.service";

export class FitActiveWorkersWoMedicalExaminationDirectDetailData {
    public columnDefinitions: ColumnDefinition[];
    public tabledata: any[][];

    constructor(columnDefinitions: ColumnDefinition[], tabledata: any[][]) {
        this.columnDefinitions = columnDefinitions;
        this.tabledata = tabledata;
    }
}

@Component({
    selector: 'fit-active-workers-wo-medical-examination-direct-kpi-service-host',
    template: '<ng-content></ng-content>',
    standalone: false
})
export class FitActiveWorkersWoMedicalExaminationDirectKpiServiceHostComponent extends DualSummaryDetailKpiServiceHost<FitActiveWorkersWoMedicalExaminationDirectService, FitActiveWorkersWoMedicalExaminationDirectServiceData, FitActiveWorkersWoMedicalExaminationDirectServiceData, FitActiveWorkersWoMedicalExaminationDirectDetailService, FitActiveWorkersWoMedicalExaminationDirectDetailServiceData, FitActiveWorkersWoMedicalExaminationDirectDetailData>
    implements OnDestroy {
    public getClassName() { return "FitActiveWorkersWoMedicalExaminationDirectKpiServiceHostComponent"; }

    private raasSubscription: Subscription;
    private officeSelectorSubscription: Subscription;
    @Input() public detailDialog: ModalDialogComponent;

    constructor(zone: NgZone, logger: LoggerService, private impersonationService: ImpersonationService, private officeSelectorService: OfficeSelectorService,
        summaryService: FitActiveWorkersWoMedicalExaminationDirectService, detailService: FitActiveWorkersWoMedicalExaminationDirectDetailService) {
        super(zone, logger, summaryService, detailService);
        this.raasSubscription = this.impersonationService.impersonationChanged.subscribe(() => { this.resetSummary(); });
        this.officeSelectorSubscription = this.officeSelectorService.selectedOfficeUpdated.subscribe(() => { this.resetSummary(); });
    }

    protected processSummaryData(data: FitActiveWorkersWoMedicalExaminationDirectServiceData): FitActiveWorkersWoMedicalExaminationDirectServiceData {
        return data;
    }

    protected getDefaultSummaryData(): FitActiveWorkersWoMedicalExaminationDirectServiceData {
        let data = new FitActiveWorkersWoMedicalExaminationDirectServiceData();
        data.consultant = 0;
        data.office = 0;
        data.updateTimestamp = new Date();

        return data;
    }

    protected extractUpdateTime(data: FitActiveWorkersWoMedicalExaminationDirectServiceData): Date {
        return data.updateTimestamp;
    }

    protected processDetailData(data: FitActiveWorkersWoMedicalExaminationDirectDetailServiceData, args: any): FitActiveWorkersWoMedicalExaminationDirectDetailData {
        if (data.workers) {
            if (args && args.filter && args.filter.consultant) {
                let columnDefinitions = this.getColumnsDefaultConsultant();

                let consultantNif = this.impersonationService.getNifSafe().toUpperCase();

                if (args && args.filter) {
                    if (args.filter.consultant) {
                        let consultantName = (this.extractConsultants(data.workers).find(x => x.userDocNumber == consultantNif) || { name: null }).name;
                        columnDefinitions[4].filterTerm = [consultantName];
                    }
                }

                let tabledata2 = [];
                let tabledata = [];
                for (let worker of data.workers) {
                    if (worker.userDocNumber.toUpperCase() == consultantNif) {
                        tabledata.push([
                            worker.workerName,
                            worker.workerPhone,
                            worker.workerEmail,
                            {
                                date: worker.examinationDate,
                                status: worker.examinationStatus
                            },
                            worker.userName,
                            worker.offerFiscalName,
                            worker.clientId,
                            worker.clientCenterId,
                            worker.clientBranchId,
                            worker.clientBranchName
                        ]);
                    }
                    else {
                        tabledata2.push([
                            worker.workerName,
                            worker.workerPhone,
                            worker.workerEmail,
                            {
                                date: worker.examinationDate,
                                status: worker.examinationStatus
                            },
                            worker.userName,
                            worker.offerFiscalName,
                            worker.clientId,
                            worker.clientCenterId,
                            worker.clientBranchId,
                            worker.clientBranchName
                        ]);
                    }
                }
                let arrayOrdenado = tabledata.concat(tabledata2);
                return new FitActiveWorkersWoMedicalExaminationDirectDetailData(columnDefinitions, arrayOrdenado);
            } else {
                let columnDefinitions = this.getColumnsDefault();

                let consultantNif = this.impersonationService.getNifSafe().toUpperCase();

                if (args && args.filter) {
                    if (args.filter.consultant) {
                        let consultantName = (this.extractConsultants(data.workers).find(x => x.userDocNumber == consultantNif) || { name: null }).name;
                        columnDefinitions[0].filterTerm = [consultantName];
                    }
                }

                let tabledata2 = [];
                let tabledata = [];
                for (let worker of data.workers) {
                    if (worker.userDocNumber.toUpperCase() == consultantNif) {
                        tabledata.push([
                            worker.userName,
                            worker.workerName,
                            worker.workerPhone,
                            worker.workerEmail,
                            {
                                date: worker.examinationDate,
                                status: worker.examinationStatus
                            },
                            worker.offerFiscalName,
                            worker.clientId,
                            worker.clientCenterId,
                            worker.clientBranchId,
                            worker.clientBranchName
                        ]);
                    }
                    else {
                        tabledata2.push([
                            worker.userName,
                            worker.workerName,
                            worker.workerPhone,
                            worker.workerEmail,
                            {
                                date: worker.examinationDate,
                                status: worker.examinationStatus
                            },
                            worker.offerFiscalName,
                            worker.clientId,
                            worker.clientCenterId,
                            worker.clientBranchId,
                            worker.clientBranchName
                        ]);
                    }
                }
                let arrayOrdenado = tabledata.concat(tabledata2);
                return new FitActiveWorkersWoMedicalExaminationDirectDetailData(columnDefinitions, arrayOrdenado);
            }
        }
        else return this.getDefaultDetailData();
    }

    private extractConsultants(data: FitWorkerDetail[]): { userDocNumber: string, name: string }[] {
        let userDocNumbers: { userDocNumber: string, name: string }[] = [];

        if (data) {
            data.forEach(x => {
                if (!userDocNumbers.find(y => x.userDocNumber.toUpperCase() == y.userDocNumber)) userDocNumbers.push({ userDocNumber: x.userDocNumber.toUpperCase(), name: x.userName });
            })
        }

        return userDocNumbers;
    }

    protected getDefaultDetailData(): FitActiveWorkersWoMedicalExaminationDirectDetailData {
        let columnDefinitions = this.getColumnsDefault();

        return new FitActiveWorkersWoMedicalExaminationDirectDetailData(columnDefinitions, []);
    }

    protected performDetailAction(): void {
        if (this.detailDialog) this.detailDialog.open();
    }

    public ngOnDestroy(): void {
        if (this.raasSubscription) this.raasSubscription.unsubscribe();
        if (this.officeSelectorSubscription) this.officeSelectorSubscription.unsubscribe();
    }

    public mergeFilter(filter: any) {
        let detailProcessingArgs = this.detailProcessingArgs || {};
        detailProcessingArgs.filter = detailProcessingArgs.filter || {};
        detailProcessingArgs.filter = { ...detailProcessingArgs.filter, ...filter };
        this.detailProcessingArgs = detailProcessingArgs;
    }

    /**
     * Método que define las columnas, sus etiquetas y medidas
     * @returns Arreglo de columnas por defecto para la grilla
     */
    public getColumnsDefault(): any {

        let columnDefinitions = [
            new TextColumnDefinition("Consultor", null, true),
            new TextColumnDefinition("Trabajador"),
            new PhoneNumberColumnDefinition("Teléfono"),
            new EmailColumnDefinition("Email"),
            new DateColumnDefinition("Fecha Apto RRMM", (data) => {
                if (data.date == null || data.date == '' || data.date == undefined) {
                    return '';
                }
                else {
                    let date = moment(data.date).startOf("day");
                    if (date.isSame(moment(new Date("0001-01-01T00:00:00")))) {
                        return data.status;
                    } else {
                        if (date.isValid()) return date.format("DD/MM/YYYY");
                        else return data.status;
                    }
                }
            }, true, 155),
            new TextColumnDefinition("Cliente", null, true),
            new TextColumnDefinition("Id Cliente", null, true),
            new TextColumnDefinition("Id Centro \nCl.", null, true, 100),
            new TextColumnDefinition("Id Ofi. \nCl.", null, true, 80),
            new TextColumnDefinition("Ofi. Cliente", null, true),
        ];

        return columnDefinitions;
    }

    /**
     * Método que define las columnas, sus etiquetas y medidas
     * @returns Arreglo de columnas por defecto para la grilla
     */
    public getColumnsDefaultConsultant(): any {

        let columnDefinitions = [
            new TextColumnDefinition("Trabajador"),
            new PhoneNumberColumnDefinition("Teléfono"),
            new EmailColumnDefinition("Email"),
            new DateColumnDefinition("Fecha Apto RRMM", (data) => {
                if (data.date == null || data.date == '' || data.date == undefined) {
                    return '';
                }
                else {
                    let date = moment(data.date).startOf("day");
                    if (date.isSame(moment(new Date("0001-01-01T00:00:00")))) {
                        return data.status;
                    } else {
                        if (date.isValid()) return date.format("DD/MM/YYYY");
                        else return data.status;
                    }
                }
            }, true, 155),
            new TextColumnDefinition("Consultor", null, true),
            new TextColumnDefinition("Cliente", null, true),
            new TextColumnDefinition("Id Cliente", null, true),
            new TextColumnDefinition("Id Centro \nCl.", null, true, 100),
            new TextColumnDefinition("Id Ofi. \nCl.", null, true, 80),
            new TextColumnDefinition("Ofi. Cliente", null, true),
        ];

        return columnDefinitions;
    }
}
